/* eslint-disable max-len */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {range} from 'core/utils';

import Button from 'components/button';

import styles from './styles.css';

export default class Navigation extends Component {
    static propTypes = {
        steps: PropTypes.number.isRequired,
        activeStep: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    }

    handleClick(step) {
        return () => this.props.onChange(step);
    }

    renderNextButton() {
        const {activeStep, steps, onClose} = this.props;

        if (activeStep === steps - 1) {
            return (
                <Button className={styles.button} theme='yellow' onClick={onClose}>
                    <i className='material-icons'>check</i> Entendido
                </Button>
            );
        }

        return (
            <Button className={styles.button} theme='white' onClick={this.handleClick(activeStep + 1)}>
                Siguiente <i className='material-icons'>arrow_right</i>
            </Button>
        );
    }

    render() {
        const {steps, activeStep} = this.props;
        return (
            <div className={styles.root}>
                <Button
                    className={classNames(styles.button, {[styles.invisible]: activeStep === 0})}
                    onClick={this.handleClick(activeStep - 1)}
                    theme='white'>
                    <i className='material-icons'>arrow_left</i> Atras
                </Button>
                <div className={styles.steps}>
                    {range(steps).map(step => (
                        <button
                            key={step}
                            className={classNames(styles.step, {[styles.active]: step === activeStep})}
                            onClick={this.handleClick(step)}
                        />
                    ))}
                </div>
                {this.renderNextButton()}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/session-organization-tutorial/navigation/index.js